import { useEffect } from "react"
import { toast } from "sonner"
import resolveEntityLink from "@/notification/resolveEntityLink"
import { ButtonLink, subscribe, useAblyAuthMutation } from "@/base"
import { useAuth } from "@/auth"
import type { FlashMessage } from "@/notification/model"

export default function useFlashMessages() {
  const { userId } = useAuth()
  const [ablyAuth] = useAblyAuthMutation()

  useEffect(() => {
    if (!userId) {
      return
    }

    let unsubscribe = () => {}
    let cancelled = false

    void (async () => {
      const unsub = await subscribe(
        `user-${userId}`,
        () => ablyAuth().unwrap(),
        {
          flash: ({ variant, message, link }: FlashMessage) => {
            toast[variant](message, {
              action: link ? (
                <ButtonLink variant="ghost" {...resolveEntityLink(link)} />
              ) : undefined,
            })
          },
        },
      )

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (cancelled) {
        // effect already cleaned up before subscribe resolved
        unsub()
      } else {
        unsubscribe = unsub
      }
    })()

    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [userId, ablyAuth])
}
